import { RefreshCw } from 'lucide-react';
import { Banner, Button } from '@dd/ui';
import { useSync } from '@/sync/status';
import { useT } from '@/lib/i18n';
import { applyUpdate, useUpdateAvailable } from '@/lib/pwa';
import { clockSkewed } from '@/lib/clock';

/** App update (HTTP 426 or a new service worker) and clock warnings. */
export function UpgradeBanner() {
  const needs = useSync((s) => s.needsUpgrade);
  const waiting = useUpdateAvailable();
  const { t } = useT();
  return (
    <>
      {(needs || waiting) && (
        <Banner tone="warn" className="m-3" action={<Button size="sm" icon={<RefreshCw size={14} />} onClick={() => void applyUpdate()}>{t('আপডেট', 'Update')}</Button>}>
          {needs ? t('অ্যাপের নতুন সংস্করণ লাগবে। আপডেট করুন।', 'A newer version of the app is required.') : t('নতুন সংস্করণ তৈরি আছে।', 'A new version is ready.')}
        </Banner>
      )}
      {clockSkewed() && <Banner tone="warn" className="mx-3 mt-3">{t('ফোনের তারিখ-সময় ঠিক নেই। রিপোর্ট ভুল হতে পারে — সেটিংসে গিয়ে ঠিক করুন।', 'Your phone clock looks wrong; reports may be off. Fix the date & time in phone settings.')}</Banner>}
    </>
  );
}
